<template>
    <section class="row align-items-center padding-top-2x padding-bottom-3x">
        <div class="col-md-5 order-md-2"><img class="d-block w-270 m-auto" :src="logoAboutShop" alt="Shop"></div>
        <div class="col-md-7 order-md-1 text-md-left text-center">
            <div class="mt-30 hidden-md-up"></div>
            <h2>{{$t("aboutShop.title")}}</h2>
            <p class="text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id purus at risus
                pellentesque faucibus a quis eros. In eu fermentum leo. Integer ut eros lacus. Proin ut accumsan leo.
                Morbi vitae est eget dolor consequat aliquam eget quis dolor. Mauris rutrum fermentum erat, at euismod
                lorem pharetra nec. Duis erat lectus, ultrices euismod sagittis at, pharetra eu nisl. Phasellus id ante
                at velit tincidunt hendrerit.</p><a class="text-decoration-none" href="contacts.html">See Outlet Stores&nbsp;<i
                class="material-icons keyboard_arrow_right lead"></i></a>
        </div>
    </section>
</template>

<script>
import logoAboutShop from "../../../../assets/img/features/04.jpg";

export default {
    name: "AboutShop",
    data() {
        return {
            logoAboutShop,
        };
    },
};

</script>

<style scoped>

</style>